import React from 'react';
import './RateTitle.less';

export const RateTitle = ({text}) => {
	return <span className="rate-title">{text}</span>
}
